/**
 * Build / version stamp. Bumps by +0.1 on every completed update.
 * Public footer + admin sidebar both render `Version {VERSION}`.
 */
export const VERSION = "6.5.13";
export const BUILT_AT = "2026-02-17";

// Kept for backwards-compat with any code still importing PUBLIC_BUILD.
export const PUBLIC_BUILD = VERSION;
